import {
    AdminCreateOrderPayload,
    UpdateOrderPayload,
    Order,
    OrderStatus,
    AdminCreateMultiOrderPayload, OrderFilter, UnpaidRecord
} from "@models/order";
import {Pagination} from "common/models/pagination";
import axios from "axios";
import {SuccessRes} from "@/model/success-res";
import {CourseType} from "@models/course";

/***
 * @GET
 * /orders
 */

export type GetOrdersParams = OrderFilter

export interface GetOrdersRes {
    orders: Order[],
    count?: number
}

export async function getOrders(params: GetOrdersParams & Partial<Pagination>) {
    return await axios.get<GetOrdersRes>('/orders', {
        params,
        token: true
    })
}

/***
 * @GET
 * /orders/{orderId}
 */

export interface GetOrderPathParams {
    id: string
}

export interface GetOrderRes {
    order: Order
}

export async function getOrder(pathParams: GetOrderPathParams) {
    return await axios.get<GetOrderRes>(`/orders/${pathParams.id}`, {
        token: true
    })
}

/***
 * @POST
 * /orders
 */

export type PostOrderBody = AdminCreateOrderPayload

export interface PostOrdersRes {
    order: Order
}

export async function postOrders(data: PostOrderBody) {
    return await axios.post<PostOrdersRes>('/orders', data, {token: true})
}

/***
 * @POST
 * /orders/multi
 */

export type PostOrdersBatchBody = AdminCreateMultiOrderPayload

export type PostOrdersBatchRes = SuccessRes

export async function postOrdersBatch(data: PostOrdersBatchBody) {
    return await axios.post<PostOrdersBatchRes>('/orders/multi', data, {token: true})
}

/***
 * @PATCH
 * /orders/{userId}
 */

export interface PatchOrderPathParams {
    id: string
}

export type PatchOrderData = UpdateOrderPayload

export async function patchOrder(pathParams: PatchOrderPathParams, data: PatchOrderData) {
    return await axios.patch<SuccessRes>(`/orders/${pathParams.id}`, data, {token: true})
}

/***
 * @GET
 * /orders/unpaid-students
 */

export interface GetUnpaidStudentsRes {
    unpaidStudents: UnpaidRecord[]
}

export async function getUnpaidStudents() {
    return await axios.get<GetUnpaidStudentsRes>('/orders/unpaid-students', {
        token: true
    })
}

/***
 * @POST
 * /orders/{orderId}/accept-payment
 */

export interface PostAcceptOrderPaymentPathParams {
    id: string
}

export type PostAcceptOrderPaymentRes = SuccessRes

export async function postAcceptOrderPayment(pathParams: PostAcceptOrderPaymentPathParams) {
    return await axios.post<PostAcceptOrderPaymentRes>(`/orders/${pathParams.id}/accept-payment`, {}, {token: true})
}

/***
 * @POST
 * /orders/{orderId}/reject-payment
 */

export interface PostRejectOrderPaymentPathParams {
    id: string
}

export type PostRejectOrderPaymentBody = {
    rejectedReason: string
}

export type PostRejectOrderPaymentRes = SuccessRes

export async function postRejectOrderPayment(pathParams: PostRejectOrderPaymentPathParams, data: PostRejectOrderPaymentBody) {
    return await axios.post<PostRejectOrderPaymentRes>(`/orders/${pathParams.id}/reject-payment`, data, {token: true})
}
